import { ChatState } from './types'

export const state: ChatState = {
  messages: [],
  totalPages: 1
}
